/**
 * @generated SignedSource<<e5c0983169d0781a26e1b15973feaf98>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventsCarouselFragment$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"EventCardFragment">;
    };
  }>;
  readonly " $fragmentType": "EventsCarouselFragment";
};
export type EventsCarouselFragment$key = {
  readonly " $data"?: EventsCarouselFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventsCarouselFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventsCarouselFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EventEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Event",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "EventCardFragment"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "EventConnection",
  "abstractKey": null
};

(node as any).hash = "6d38a6fb09e559e746dbc5041b793518";

export default node;
